import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ApiService } from 'src/services/apiService';

@Component({
  selector: 'app-electronic-arrest-order',
  standalone: true,
  imports:[
    FormsModule,
    ProgressSpinnerModule,
  ],
  templateUrl: './electronic-arrest-order.component.html',
  styleUrl: './electronic-arrest-order.component.css'
})
export class ElectronicArrestOrderComponent {

  fromDate:string|undefined;
  toDate:string|undefined;
  isLoading=false;

  incomeSum:number|undefined;
  trustsSum:number|undefined;

  constructor(private apiService:ApiService){

  }

  getData(){

    this.isLoading=true;

    var body={
      "fromDate":  this.fromDate,
      "toDate": this.toDate
    };

    var request= this.apiService.post("moin/ElectronicArrestOrder",body);

    request.subscribe(response=>{

      var data=response.data;

      this.incomeSum=data.incomeSum;
      this.trustsSum=data.trustsSum;

      this.isLoading=false;
      
    });
  }



}
